import { ReactNode } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import { useTheme } from '../../providers/MySettings/Hooks/useTheme';

const backgroundColors = {
  darkMode: "#7693B1",
  lightMode: "#87A2BF",
};

const foregroundColors = {
  darkMode: "#355572",
  lightMode: "#f6f9fe",
};

type Props = {
  children: ReactNode;
} & IContentLoaderProps;

export const ThemedContentLoader = ({ children, ...rest }: Props) => {
  const { currentTheme } = useTheme();
  const backgroundColor = backgroundColors[currentTheme];
  const foregroundColor = foregroundColors[currentTheme];
  return (
    <ContentLoader
      className="content-loader"
      speed={4}
      backgroundOpacity={0.2}
      width={1594}
      height={289}
      viewBox="0 0 1594 289"
      preserveAspectRatio="none"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      {...rest}
    >
      {children}
    </ContentLoader>
  );
}